import axios from 'axios';
import { API_BASE_URL } from '../api';

/**
 * Classify a garment design image: category, product type (or other), sketch vs photorealistic.
 * @param {string} imageUrl - Public URL of the garment image (e.g. after S3 upload)
 * @returns {Promise<{ success: boolean, data?: { analysis: object, processingTime: number, modelUsed: string } }>}
 */
export const analyzeGarment = async (imageUrl) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/garment-analysis`,
      { imageUrl },
      {
        headers,
        timeout: 120000,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Garment analysis API error:', error);
    if (error.code === 'ECONNABORTED') {
      throw new Error('Garment analysis timed out. Please try again.');
    }
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to analyze garment');
    }
    throw error;
  }
};
